import { Result } from '@standardnotes/domain-core';
export class DecryptErroredPayloads {
    constructor(itemsEncryption, _decryptErroredRootPayloads) {
        this.itemsEncryption = itemsEncryption;
        this._decryptErroredRootPayloads = _decryptErroredRootPayloads;
    }
    async execute() {
        await this._decryptErroredRootPayloads.execute();
        await this.itemsEncryption.decryptErroredItemPayloads();
        return Result.ok();
    }
}
